import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import Config, {
  PERMISSION_ROLE_HIS_PAYMENT,
  PROMOTION_CODES,
  REQUIRED_CTKM,
  REQUIRED_CTKM_DISCOUNT,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsAutocompleteTextAndSelect from "app/common/form/GlobitsAutocompleteTextAndSelect";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  isPaid,
  LEAD_SOURCE_LEVEL,
  PathModule,
  POPUP_TYPE_PRODUCT,
} from "app/common/LocalConst";
import {
  formatMoney,
  getDepartmentsUser,
  getPriceTypeService,
  getPromotionCodes,
  isAdmin,
  isRoleHisPayment,
  transformDate,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
} from "app/common/LocalFunction";
import DeductionList from "app/PatientManagement/DeductionList/DeductionList";
import { getListCode } from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingDrug } from "app/services/DrugService";
import { pagingProgram } from "app/services/PromotionCRMService";
import { pagingQuantityUnit } from "app/services/QuantityUnitService";
import { searchItemByPage } from "app/services/ScreenTemplateService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import * as Yup from "yup";
import RowTotalChangeService from "../../AllServicesTab/Component/RowTotalChangeService";
import RegisterServiceStaffsRevenue from "../../RegisterServiceTreatmentPlanTab/Popup/RegisterServiceStaffsRevenue";
const RegisterProductPopup = ({
  open,
  handleClose,
  onSubmit,
  initRegisterProduct,
  listVatPercent,
  resetPopupStore,
  customerSourceWalkIn,
  handleAfterSubmit,
  defaultFreePromotion,
}) => {
  const validationSchema = Yup.object().shape({
    drug: Yup.object().nullable().required("Chưa chọn sản phẩm!"),
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    orderDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày đăng ký chưa đúng định dạng!")
      .nullable()
      .required("Chưa nhập ngày đăng ký"),
    percentDiscount: Yup.number()
      .min(0, "Giảm giá phải lớn hơn 0!")
      .max(100, "Giảm giá không vượt quá  100!")
      .test(
        "validate-percentDiscount",
        "Không được quá % giảm giá của chương trình khuyến mãi này",
        function (value) {
          const { promotionProgram } = this.parent;
          if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return true;

          if (
            promotionProgram &&
            promotionProgram?.allProductMaxDiscountPercent != null
          ) {
            if (value > promotionProgram?.allProductMaxDiscountPercent)
              return false;
          }
          if (promotionProgram && promotionProgram?.products?.length > 0) {
            if (value > promotionProgram?.products[0]?.maxDiscountPercent)
              return false;
          }
          return true;
        }
      )

      .nullable(),
    discount: Yup.number()
      .nullable()
      .test(
        "less-than-or-equals-to-totalAmount",
        "Tiền giảm giá không được lớn hơn tổng tiền",
        function (discount) {
          const { totalAmount } = this.parent;
          if (discount > totalAmount) return false;
          return true;
        }
      ),
    soldQuantity: Yup.string().nullable().required("Chưa nhập số lượng!"),
    price: Yup.number()
      .moreThan(0, "Giá phải lớn hơn 0!")
      .nullable()
      .required("Chưa nhập giá!"),

    totalAmount: Yup.number()
      .typeError("Thành tiền phải là số")

      .test(
        "validate-amount",
        "Không được bán dưới mức giá tối thiểu",
        function (value) {
          const { drug, soldQuantity } = this.parent;
          if (!drug?.minSellingPrice || !value) {
            return true;
          } else {
            let minSellingPriceVal = value / soldQuantity;
            if (minSellingPriceVal < drug?.minSellingPrice) {
              return false;
            }
            return true;
          }
        }
      )
      .nullable(),
    staffRevenues: Yup.array()
      .min(1, "Cần thêm ít nhất 1 phân bổ!")
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object()
              .nullable()
              .required("Bắt buộc nhập nguồn phân bổ")
              .test(
                "source-in-list",
                "Nguồn phân bổ không hợp lệ",
                function (value) {
                  const listCodeSource =
                    this.options.context?.listCodeSource || [];

                  // Nếu chưa chọn hoặc thiếu code → invalid
                  if (!value || !value.code) return false;

                  // Không có danh sách thì cho pass
                  if (listCodeSource.length === 0) return true;

                  const first = listCodeSource[0];

                  // Mảng string: ["CTV", "KR", ...]
                  if (typeof first === "string") {
                    return listCodeSource.includes(value.code);
                  }

                  // Mảng object: [{code: "CTV"}]
                  if (typeof first === "object" && first !== null) {
                    return listCodeSource.some(
                      (item) => item.code === value.code
                    );
                  }

                  return false;
                }
              ),
            actualAmount: Yup.mixed()
              .nullable()
              .test("greater-than-zero", "Giá trị phải lớn hơn 0!", (value) => {
                if (value === null || value === "") return true;
                return typeof value === "number" && value >= 0;
              }),
            percentRevenue: Yup.mixed()
              .nullable()
              .test(
                "max-100",
                "Phân bổ doanh thu phải nhỏ hơn hoặc bằng 100!",
                (value) => {
                  if (value === null || value === "") return true;
                  return typeof value === "number" && value <= 100;
                }
              ),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )
      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),

    percentRevenue: Yup.number()
      .nullable()
      .min(0, "Tối thiểu 0%")
      .max(100, "Tối đa 100%"),
    ...(REQUIRED_CTKM
      ? {
        promotionProgram: Yup.object().nullable().required("Chưa chọn CTKM!"),
      }
      : {}),
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const { handleGetListVatPercent, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const { listCodeSource } =
    useStore().patientManagementStore.registerProductStore;

  const handleGetListCodeSource = async (obj, setFieldValue) => {
    try {
      const { data } = await getListCode(obj);
      setFieldValue("listCodeSource", data || []);
    } catch (error) {
      //console.error(error);
    }
  };

  const department = useDefaultDepartment();
  const source = initialPatient?.patientInfo?.currentPatientSource;

  useEffect(() => {
    handleGetListVatPercent();
    return () => resetPopupStore();
  }, []);

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`${initRegisterProduct?.id
          ? initRegisterProduct?.isDisabled
            ? "Xem thông tin"
            : "Chỉnh sửa"
          : "Thêm"
        }  sản phẩm`}
      formik={{
        //initialValues: initRegisterProduct,
        initialValues: {
          department,
          // promotionProgram: defaultFreePromotion,
          ...initRegisterProduct,
          sourceRevenue: source,
          listCodeSource: listCodeSource,
        },
        onSubmit: async (values) => {
          let data = await onSubmit(values);
          if (handleAfterSubmit && data?.drugOrder?.responseStatus !== false) {
            handleAfterSubmit();
          }
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ isSubmitting, setFieldValue, submitForm, values }) => {
        const isDisabled = values?.isDisabled;

        return (
          <div className="flex-center gap-1">
            {!initRegisterProduct?.id && !isDisabled && (
              <CommonButton
                className="btn-primary"
                disabled={isSubmitting}
                onClick={async () => {
                  await setFieldValue("isContinue", true);
                  await submitForm();
                }}
              >
                {!isMobile && <Save className="mr-2 " />}
                {`${"Thêm và kê tiếp"}  sản phẩm`}
              </CommonButton>
            )}
            {!isDisabled && (
              <CommonButton
                type="submit"
                className="btn-primary"
                disabled={isSubmitting}
              >
                {!isMobile && <Save className="mr-2 " />}
                {`${initRegisterProduct?.id ? "Chỉnh sửa" : "Thêm"} sản phẩm`}
              </CommonButton>
            )}

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listVatPercent={listVatPercent}
              patient={initialPatient?.patientInfo}
              customerSourceWalkIn={customerSourceWalkIn}
              handleGetListCodeSource={handleGetListCodeSource}
              initRegisterProduct={initRegisterProduct}
            />
            <DialogError
              patient={initialPatient?.patientInfo}
              values={values}
              setFieldValue={setFieldValue}
              initRegisterProduct={initRegisterProduct}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({
    listVatPercent,
    patient,
    customerSourceWalkIn,
    initRegisterProduct,
    handleGetListCodeSource,
  }) => {
    const { setFieldValue, values } = useFormikContext();
    // const [popupData, setPopupData] = useState(null);

    const isDisabled =
      values?.isDisabled ||
      isPaid({ value: values?.paymentStatus }) ||
      values?.treatmentPlanCard; // thuoc liẹu trình cũng disable,chỉ cho phân bổ

    const handleAllocationRevenue = (totalAmount, staffRevenues, oldCredit) => {
      const dataTotalAmount = totalAmount - oldCredit; // sử dụng tiền sau khi trừ đi tiền khấu trừ
      const { percentDifferenceOld, percentRevenueNew } =
        handleCalPercentRevenue(dataTotalAmount);

      staffRevenues = staffRevenues?.map((el) => {
        if (el?.originTreatmentId) {
          //xử lí tk cũ
          let percentRevenue = percentDifferenceOld * el?.percentRevenue;

          const actualAmount = Number(
            ((percentRevenue * dataTotalAmount) / 100).toFixed(4)
          );
          return {
            ...el,
            percentRevenue,
            actualAmount,
          };
        } else {
          let percentRevenue = percentRevenueNew > 0 ? percentRevenueNew : 0;
          const actualAmount = Number(
            ((percentRevenue * dataTotalAmount) / 100).toFixed(4)
          );
          return {
            ...el,
            percentRevenue,
            actualAmount,
          };
        }
      });
      return staffRevenues;
    };

    const handleCalPercentRevenue = (dataTotalAmount) => {
      if (!(dataTotalAmount > 1)) {
        return {
          percentDifferenceOld: 100,
          percentRevenueNew: 100,
        };
      }
      let percentDifferenceOld;
      let percentRevenueNew; //cth tính doanh thu dựa trên đã trả tiền hay chưa
      //nếu chưa trả thì lấy tiền phải trả / tổng để tính % ông cũ,
      // ông mới thì lấy tổng cần thu -  phải trả / tổng cần thu
      if (values?.oldProduct?.totalBillPatientPaid > 0) {
        const remaining =
          values?.oldProduct?.amountActuallyPaid -
          values?.oldProduct?.totalBillPatientPaid || 0;
        percentDifferenceOld = remaining / dataTotalAmount;

        percentRevenueNew =
          ((dataTotalAmount - remaining) / dataTotalAmount) * 100;
      } else {
        percentDifferenceOld =
          values?.oldProduct?.amountActuallyPaid / dataTotalAmount;
        percentRevenueNew =
          ((dataTotalAmount - values?.oldProduct?.amountActuallyPaid) /
            dataTotalAmount) *
          100;
      }
      return {
        percentDifferenceOld:
          percentDifferenceOld > 0 ? percentDifferenceOld : 0,
        percentRevenueNew: percentRevenueNew > 0 ? percentRevenueNew : 0,
      };
    };

    let totalAmountRevenues = 0;
    if (values?.priceWithTax) {
      totalAmountRevenues =
        +values?.totalAmount - (+values?.discount || 0) || 0;
    } else {
      totalAmountRevenues =
        +values?.totalAmount -
        (+values?.discount || 0) +
        (+values?.taxTotal || 0) || 0;
    }
    const [checkedState, setCheckedState] = useState(false);
    // Có dữ liệu cấn trừ hay không
    const hasData =
      (values?.voucherAllocations?.length || 0) > 0 ||
      (values?.invoiceItemAllocations?.length || 0) > 0;
    // Đang chỉnh sửa
    const isEdit = Boolean(initRegisterProduct?.id);
    // Checkbox hiển thị
    const checked = checkedState || hasData;
    // Disable CHỈ khi edit
    const disabled = isEdit && hasData;
    return (
      <>
        <Grid container spacing={1} className="register-form">
          <Grid item xs={12} md={9}>
            <div className="sv-section-title">🔁 Thông tin đăng ký</div>
            <BodyForm
              isDisabled={isDisabled}
              patient={patient}
              customerSourceWalkIn={customerSourceWalkIn}
              listVatPercent={listVatPercent}
              handleAllocationRevenue={handleAllocationRevenue}
              handleGetListCodeSource={handleGetListCodeSource}
              checked={checked}
              disabled={disabled}
              setCheckedState={setCheckedState}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <RowTotalChangeService data={values} />
          </Grid>

          {/* Danh sách trừ tiền cọc và đơn hàng */}
          {checked && (
            <Grid item xs={12} md={12}>
              <DeductionList initRegisterProduct={initRegisterProduct} />
            </Grid>
          )}

          <Grid item xs={12} md={12}>
            <span class="symbol sv-section-title">⏳ Phân bổ</span>
            <div className="new-product-section">
              <Grid container spacing={1}>
                <RegisterServiceStaffsRevenue
                  // isDisabled={isDisabled}
                  totalAmount={totalAmountRevenues}
                  popupType={POPUP_TYPE_PRODUCT}
                />
              </Grid>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
);

const DialogError = observer(({ patient, values, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().patientManagementStore.registerProductStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            // khi đóng popup thì reset lại ngày đăng kí
            if (!values?.id) {
              setFieldValue("orderDate", new Date());
            }
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

const OldDrug = observer(() => {
  const { values, setFieldValue } = useFormikContext();
  const drug = values?.oldDrugOrder?.drug;
  return (
    <Grid container spacing={1} className="flex align-center justify-between">
      <Grid item xs={12} md={3}>
        <div className="pl-1 pr-1">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              className="service-name"
              style={{
                cursor: "pointer",
              }}
            >
              {drug?.name}
            </span>
            {values?.oldDrugOrder?.treatmentPlanCard && (
              <i>
                <span>
                  <Tooltip title="Đã thu">
                    <b style={{ color: "green" }}>
                      {formatMoney(
                        +values?.oldDrugOrder?.totalBillPatientPaid || 0
                      )}
                    </b>
                  </Tooltip>
                </span>
                /
                <span>
                  <Tooltip title="Cần thu">
                    <b style={{ color: "red" }}>
                      {formatMoney(
                        values?.oldDrugOrder?.amountActuallyPaid || 0
                      )}
                    </b>
                  </Tooltip>
                </span>
              </i>
            )}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsNumberInput
          name="remainingQuantity"
          label="Số lượng còn lại"
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldDrugOrder.totalUsed"
          label="Tổng tiền đã dùng"
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldDrugOrder.remainingAmount"
          label="Tổng tiền còn lại"
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldCredit"
          label="Tiền khấu trừ sản phẩm cũ"
          disabled
        // onChange={(e) => {
        //   let oldCredit = +e?.target?.value;
        //   setFieldValue("oldCredit", oldCredit);
        //   let newStaffRevenues = [
        //     ...staffRevenuesOld,
        //     ...(values?.staffRevenues?.length > 0
        //       ? values?.staffRevenues?.filter((el) => !el?.originTreatmentId)
        //       : []),
        //   ];
        //   const staffRevenues = handleAllocationRevenue(
        //     values?.totalAmount - (values?.discount || 0),
        //     newStaffRevenues,
        //     oldCredit
        //   );

        //   let formatDataService;
        //   let formatDataDrug;
        //   const discount = +values?.discount || 0;

        //   // lấy theo giá tổng // logic giá tổng = tổng giá thành phần ,nếu ko = thì phân bổ tiền sang giảm giá
        //   if (!values?.isTotalPriceUsed) {
        //     const percentAllocateItem =
        //       (oldCredit + discount) / values?.totalAmount;

        //     formatDataService = values?.paServiceRegister?.map((el) => {
        //       return {
        //         ...el,
        //         percentDiscount: percentAllocateItem * 100,
        //         discount:
        //           percentAllocateItem *
        //           el?.price *
        //           (el?.unLimited ? 1 : el?.quantity),
        //       };
        //     });

        //     formatDataDrug = values?.drugs?.map((el) => {
        //       return {
        //         ...el,
        //         percentDiscount: percentAllocateItem * 100,
        //         discount:
        //           percentAllocateItem *
        //           el?.price *
        //           (el?.unLimited ? 1 : el?.quantity),
        //       };
        //     });
        //   }

        //   setFieldValue("paServiceRegister", formatDataService);
        //   setFieldValue("drugs", formatDataDrug);
        //   setFieldValue("staffRevenues", staffRevenues);
        // }}
        />
      </Grid>
    </Grid>
  );
});

export const BodyForm = observer(
  ({
    isDisabled,
    patient,
    customerSourceWalkIn,
    listVatPercent,
    handleGetListCodeSource,
    checked,
    disabled,
    setCheckedState,
    isEdit,
  }) => {
    let isPaymentPermission = isRoleHisPayment();
    let listFreeCode = getPromotionCodes();

    const { values, setFieldValue } = useFormikContext();
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;
    const isAdminPermission = isAdmin();
    const departmentsUser = getDepartmentsUser();
    return (
      <>
        <div className="new-product-section">
          {values?.oldDrugOrder && (
            <Grid
              container
              spacing={1}
              style={{ backgroundColor: "aliceblue", marginBottom: "8px" }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <OldDrug />
              </Grid>
            </Grid>
          )}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={2}>
              <GlobitsPagingAutocomplete
                api={
                  isAdminPermission
                    ? pagingDepartment
                    : async () => ({
                      data: {
                        content: departmentsUser || [],
                        totalElements: departmentsUser?.length || 0,
                        totalPages: 1,
                      },
                    })
                }
                name={"department"}
                onChange={(_, value) => {
                  setFieldValue("department", value);
                  const searchCodeSource = {
                    level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                    startDate: values?.orderDate,
                    patientId: values?.patientId,
                    departmentId: value?.id,
                    voucherIds: Array.isArray(values?.voucherAllocations)
                      ? values.voucherAllocations
                        .map((item) => item?.voucher?.id)
                        .filter(Boolean)
                      : [],

                    invoiceItemIds: Array.isArray(
                      values?.invoiceItemAllocations
                    )
                      ? values.invoiceItemAllocations
                        .map((item) => item?.invoiceItem?.id)
                        .filter(Boolean)
                      : [],
                  };

                  handleGetListCodeSource(searchCodeSource, setFieldValue);
                }}
                label="Cơ sở"
                disabled={isDisabled}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <GlobitsDateTimePicker
                name={"orderDate"}
                label="Ngày đăng ký"
                maxDateMessage="Ngày đăng ký phải trước ngày hiện tại"
                maxDate={new Date()}
                isDateTimePicker
                required
                disabled={isDisabled}
                onChange={(value) => {
                  setFieldValue("orderDate", value);
                  if (!value) return;

                  const searchCodeSource = {
                    level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                    startDate: value,
                    patientId: values?.patientId,
                    voucherIds: Array.isArray(values?.voucherAllocations)
                      ? values.voucherAllocations
                        .map((item) => item?.voucher?.id)
                        .filter(Boolean)
                      : [],

                    invoiceItemIds: Array.isArray(
                      values?.invoiceItemAllocations
                    )
                      ? values.invoiceItemAllocations
                        .map((item) => item?.invoiceItem?.id)
                        .filter(Boolean)
                      : [],
                  };

                  handleGetListCodeSource(searchCodeSource, setFieldValue);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <GlobitsPagingAutocomplete
                label={"Sản phẩm"}
                api={pagingDrug}
                name={"drug"}
                disabled={isDisabled}
                required
                searchObject={{
                  isUsing: true,
                  isApply: true,
                }}
                getOptionLabel={(drug) => {
                  if (!drug) return "";
                  const code = drug?.code || "";
                  const name = drug?.productName || drug?.name || "";
                  return `${code} - ${name}`;
                }}
                onChange={(_, value) => {
                  setFieldValue("drug", value);
                  setFieldValue("name", value?.name);
                  setFieldValue("usedUnit", value?.unit);

                  let feeItem =
                    value?.drugUnitPrices?.length > 0
                      ? getPriceTypeService(
                        getIn(values, "patientTypeService"),
                        value?.drugUnitPrices
                      )
                      : null;

                  setFieldValue("price", feeItem?.price || value?.price);
                  setFieldValue("priceWithTax", feeItem?.isTaxIncluded);

                  setFieldValue("patientTypeService", {
                    ...feeItem?.patientTypeService,
                    price: feeItem?.price,
                  });

                  let taxPercent =
                    feeItem?.serviceVAT?.vatPercent?.toString() || 0;

                  setFieldValue("taxPercent", taxPercent);

                  let taxTotal;
                  if (feeItem?.isTaxIncluded) {
                    taxTotal =
                      ((feeItem?.price * values?.soldQuantity -
                        values?.discount) /
                        (+taxPercent + 100)) *
                      +taxPercent;
                  } else {
                    taxTotal =
                      (feeItem?.price * values?.soldQuantity -
                        values?.discount) *
                      ((+taxPercent || 0) / 100);
                  }

                  setFieldValue("taxTotal", taxTotal);

                  setFieldValue(
                    "totalAmount",
                    values?.soldQuantity * feeItem?.price
                  );

                  let revenueAllocations = value?.revenueAllocations;
                  if (revenueAllocations) {
                    let staffRevenues = revenueAllocations?.map((el) => ({
                      position: el?.position,
                      percentRevenue: el?.commissionRate,
                      source: patient?.currentPatientSource
                        ? patient?.currentPatientSource
                        : customerSourceWalkIn,
                      staff:
                        currentConsultant?.position?.code === el?.position?.code
                          ? currentConsultant
                          : currentTelesale?.position?.code ===
                            el?.position?.code
                            ? currentTelesale
                            : null,
                    }));
                    setFieldValue("staffRevenues", staffRevenues);
                  } else {
                    setFieldValue("staffRevenues", []);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <GlobitsTextField
                name={"name"}
                label="Tên sản phẩm đăng ký"
              // disabled={isDisabled}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2} className="flex align-end  ">
              <GlobitsPagingAutocomplete
                label={"Cách dùng"}
                api={searchItemByPage}
                name={"howToUse"}
                disabled={isDisabled}
                freeSolo
                displayValue="value"
                displayLabel="value"
                displaySelected="value"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <GlobitsAutocomplete
                label={"Loại giá"}
                disabled={isDisabled}
                options={values?.drug?.drugUnitPrices?.map((item) => ({
                  ...item?.patientTypeService,
                  price: item?.price,
                  vatIncluded: item?.isTaxIncluded,
                  serviceVAT: item?.serviceVAT,
                }))}
                onChange={(_, value) => {
                  setFieldValue("patientTypeService", value);
                  let vatPercent = +value?.serviceVAT?.vatPercent || 0;
                  setFieldValue("price", value?.price);
                  setFieldValue("priceWithTax", value?.isTaxIncluded);
                  setFieldValue("taxPercent", vatPercent?.toString());

                  let taxTotal;
                  if (value?.isTaxIncluded) {
                    taxTotal =
                      ((value?.price * values?.soldQuantity -
                        values?.discount) /
                        (vatPercent + 100)) *
                      vatPercent;
                  } else {
                    taxTotal =
                      (value?.price * values?.soldQuantity - values?.discount) *
                      ((vatPercent || 0) / 100);
                  }
                  setFieldValue("taxTotal", taxTotal);
                }}
                name={"patientTypeService"}
                getOptionLabel={(option) => {
                  return option?.name
                    ? `${option.name}${option?.price ? `: ${formatMoney(option.price)}` : ""
                    }`
                    : "";
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <GlobitsPagingAutocomplete
                label={"Đơn vị tính"}
                disabled
                api={pagingQuantityUnit}
                name={"usedUnit"}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <GlobitsNumberInput
                label={"Số lượng"}
                name={"soldQuantity"}
                disabled={isDisabled}
                onChange={(e) => {
                  let soldQuantity = +e.target.value;
                  setFieldValue("soldQuantity", soldQuantity);
                  if (values?.price) {
                    setFieldValue("totalAmount", soldQuantity * values?.price);
                  }

                  // Clear CTKM khi thay đổi số lượng
                  if (values?.promotionProgram) {
                    setFieldValue("promotionProgram", null);
                    setFieldValue("discount", 0);
                    setFieldValue("percentDiscount", 0);
                  }
                }}
                required
              />
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <GlobitsVNDCurrencyInput
                label={"Giá"}
                name={"price"}
                disabled={
                  (PERMISSION_ROLE_HIS_PAYMENT && !isPaymentPermission) ||
                  isDisabled
                }
                onChange={(e) => {
                  let price = e.target.value;
                  setFieldValue("price", price);
                  let totalAmount = values?.soldQuantity * price;
                  setFieldValue("totalAmount", totalAmount);
                  let discount = values?.discount;
                  if (values?.percentDiscount) {
                    discount = (totalAmount * values?.percentDiscount) / 100;
                    setFieldValue("discount", discount);
                  }

                  let taxTotal;
                  if (values?.priceWithTax) {
                    taxTotal =
                      ((totalAmount - discount) / (+values?.taxPercent + 100)) *
                      +values?.taxPercent;
                  } else {
                    taxTotal =
                      (totalAmount - discount) *
                      ((+values?.taxPercent || 0) / 100);
                  }
                  setFieldValue("taxTotal", taxTotal);
                }}
                required
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2} container alignItems="center">
              <GlobitsCheckBox
                label={"Giá kèm thuế"}
                name={"priceWithTax"}
                disabled
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <GlobitsVNDCurrencyInput
                label={"Thành tiền"}
                name={"totalAmount"}
                disabled={isDisabled}
                onChange={(e) => {
                  let totalAmount = e.target.value;
                  setFieldValue("totalAmount", totalAmount);
                  let discount = values?.discount;
                  if (values?.percentDiscount) {
                    discount = (totalAmount * values?.percentDiscount) / 100;
                    setFieldValue("discount", discount);
                  }
                  let taxTotal;
                  if (values?.priceWithTax) {
                    taxTotal =
                      ((totalAmount - discount) / (+values?.taxPercent + 100)) *
                      +values?.taxPercent;
                  } else {
                    taxTotal =
                      (totalAmount - discount) *
                      ((+values?.taxPercent || 0) / 100);
                  }

                  setFieldValue("taxTotal", taxTotal);
                }}
                required
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <GlobitsPagingAutocomplete
                api={pagingProgram}
                searchObject={{
                  codes: listFreeCode,
                  productCode: values?.drug?.code,
                  isPaying: false,
                }}
                label={"Chương trình khuyến mãi"}
                name={`promotionProgram`}
                disabled={isDisabled}
                getOptionDisabled={(option) => {
                  // Lấy giá trị hiện tại: đơn giá * số lượng - tiền khấu trừ (nếu có)
                  const currentAmount =
                    (values?.price || 0) * (values?.quantity || 1) -
                    (values?.oldCredit || values?.oldTreatmentCredit || 0);
                  // Disable option nếu giá trị đơn hàng tối thiểu > 0 và thành tiền < giá trị đơn hàng tối thiểu
                  if (
                    option?.minInvoiceAmount > 0 &&
                    currentAmount < option?.minInvoiceAmount
                  ) {
                    return true;
                  }
                  return false;
                }}
                onChange={(_, value) => {
                  setFieldValue(`promotionProgram`, value);
                  if (!value) {
                    // Tính lại thành tiền khi bỏ chọn CTKM
                    const price = values?.price || 0;
                    const quantity = values?.quantity || 1;
                    const newTotalAmount = price * quantity;

                    setFieldValue("discount", 0);
                    setFieldValue("percentDiscount", 0);
                    setFieldValue("totalAmount", newTotalAmount);
                  }
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <GlobitsNumberInput
                label={"% giảm giá"}
                name={"percentDiscount"}
                disabled={
                  isDisabled ||
                  (REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram)
                }
                onChange={(e) => {
                  let percentDiscount = +e?.target.value;
                  setFieldValue("percentDiscount", percentDiscount);
                  setFieldValue(
                    "discount",
                    (values?.price * values?.soldQuantity * percentDiscount) /
                    100
                  );
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <GlobitsVNDCurrencyInputOnlyChange
                isOnlyOnChange
                label={"Số tiền giảm"}
                name={"discount"}
                disabled={
                  isDisabled ||
                  (REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram)
                }
                onChange={(e) => {
                  let discount = +e?.target.value;
                  setFieldValue("discount", discount);
                  const totalAmount = values?.price * values?.soldQuantity;
                  let percentDiscount = (discount / totalAmount) * 100;
                  setFieldValue("percentDiscount", percentDiscount);

                  let taxTotal;
                  if (values?.priceWithTax) {
                    taxTotal =
                      ((values?.price * values?.soldQuantity - discount) /
                        (+values?.taxPercent + 100)) *
                      +values?.taxPercent;
                  } else {
                    taxTotal =
                      (values?.price * values?.soldQuantity - discount) *
                      ((+values?.taxPercent || 0) / 100);
                  }

                  setFieldValue("taxTotal", taxTotal);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={1}>
              <GlobitsAutocompleteTextAndSelect
                options={listVatPercent || []}
                label={"% Vat"}
                name={"taxPercent"}
                value={values?.taxPercent}
                disabled={values?.priceWithTax}
                onInputChange={(newValue) => {
                  setFieldValue("taxPercent", newValue?.toString());
                  let taxTotal;
                  if (values?.priceWithTax) {
                    taxTotal =
                      ((values?.price * values?.soldQuantity -
                        values?.discount) /
                        (+newValue + 100)) *
                      +newValue;
                  } else {
                    taxTotal =
                      (values?.price * values?.soldQuantity -
                        values?.discount) *
                      (+newValue / 100);
                  }

                  setFieldValue("taxTotal", taxTotal);
                }}
                displayLabel={"vatPercent"}
                onChange={(value) => {
                  setFieldValue("taxPercent", value?.vatPercent?.toString());
                  let taxTotal;

                  if (values?.priceWithTax) {
                    taxTotal =
                      ((values?.price * values?.soldQuantity -
                        values?.discount) /
                        (+value?.vatPercent + 100)) *
                      +value?.vatPercent;
                  } else {
                    taxTotal =
                      (values?.price * values?.soldQuantity -
                        values?.discount) *
                      ((+value?.vatPercent || 0) / 100);
                  }

                  setFieldValue("taxTotal", taxTotal);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <GlobitsVNDCurrencyInput
                label={"Tiền Vat"}
                name={`taxTotal`}
                disabled
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <GlobitsVNDCurrencyInput
                label="Số dư"
                name={`retainedAmount`}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <GlobitsTextField label={"Ghi chú"} name={"note"} isTextArea />
            </Grid>
            <Grid item xs={6} sm={6} md={3} container alignItems="center">
              <GlobitsCheckBox
                label="Cấn trừ từ đơn hàng/tiền cọc"
                checked={checked}
                disabled={disabled}
                onChange={(e) => {
                  const value = e.target.checked;
                  setCheckedState(value);
                  if (!value && !isEdit) {
                    setFieldValue("voucherAllocations", []);
                    setFieldValue("invoiceItemAllocations", []);
                  }
                }}
              />
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
);

export default memo(observer(RegisterProductPopup));
